<template>
  <div id="timezone_modal" class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
          <h4 class="modal-title">TIME ZONE SETTING</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="alert alert-dismissable" v-show="showAlert" v-bind:class="alertType">
                <strong>{{ alertMessagePre }}</strong> {{ alertMessage }}
              </div>
              <div class="form-group" v-if="timezones.length && !saving">
                <label>Time Zone</label>
                <select class="form-control" v-model="timezone">
                    <option v-for="timezone in timezones" v-bind:value="timezone.key">{{ timezone.label }}</option>
                </select>
              </div>
              <template v-else>
                <vue-spinner></vue-spinner>
              </template>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn green mt-ladda-btn ladda-button timezone-btn" @click.prevent="saveTimezone" data-style="expand-left">
            <span class="ladda-label">Save Changes</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { HTTP, ERROR, updateUserInfo, getUserInfo } from '@/http-common';
  import Spinner from '@/components/Spinner';
  import _ from 'lodash';

  export default {
    data() {
      return {
        timezone: getUserInfo('time_zone'),
        showAlert: false,
        alertMessage: '',
        alertMessagePre: '',
        alertType: '',
        timezones: [],
        saving: false
      }
    },
    components: {
      'vue-spinner': Spinner,
    },
    methods: {

      bindEvents() {
        var self = this;
        $('#timezone_modal').on('hidden.bs.modal', function () {
          self.showAlert = false;
        });
        $('#timezone_modal').on('show.bs.modal', function () {
          self.getTimezones();
        });
      },

      saveTimezone() {

        this.button = Ladda.create(document.querySelector('.timezone-btn'));
        this.button.start();

        HTTP.post(`users/timezone`, {
          time_zone: this.timezone
        })
          .then(response => {
            ERROR(response);
            if(response.data.status == 'success') {
              this.saving = true;
              updateUserInfo('time_zone', this.timezone);
              _.delay(() => {
                localStorage.removeItem('id_token');
                localStorage.removeItem('user_account');
                this.$router.push('/login');
              }, 3000);
            }
            this.displayAlert(response);
          }).catch(err => {
          this.button.stop();
          console.log(err);
        })

      },

      displayAlert(response) {
        this.showAlert = false;
        if(response.data.status == 'success') {
          this.alertMessage = response.data.data[0];
          this.alertMessagePre = 'Success!';
          this.alertType = 'alert-success';
        } else {
          this.alertMessage = response.data.message;
          this.alertMessagePre = 'Error!';
          this.alertType = 'alert-danger';
        }
        this.showAlert = true;
      },
      getTimezones() {
        HTTP.post(`users/timezones/index`)
          .then(response => {
            ERROR(response);
            if(response.data.status == 'success') {
              this.timezones = response.data.data.timezones;
            }
          }).catch(err => {
          console.log(err);
        })
      }
    },

    mounted() {
      this.bindEvents();
    }

  }
</script>
<style scoped>
  .modal .modal-dialog{
    right: 20px;
    margin: initial;
    left: initial;
    float: right;
    top: 90px;
  }
  @media only screen and (max-width: 470px) {
    .modal .modal-dialog{
      right: 0px;
      left: 0px;
      margin: 0 auto;
      float:initial;
    }
  }
</style>



// WEBPACK FOOTER //
// TimeZone.vue?0487fb64